import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MycontentserviceService } from './mycontentservice.service';
import { DownloadProgressService } from './download-progress.service';

type IOSHandler =
  | 'loginHandler'
  | 'iosVideoPlayer'
  | 'downloadHandler'
  | 'iapHandler';

@Injectable({ providedIn: 'root' })
export class IosBridgeService {
  userId
  constructor(
    private router: Router, 
    private ngZone: NgZone,
    private mycontentService: MycontentserviceService,
    private downloadProgressService: DownloadProgressService
    ) {
    this.userId = localStorage.getItem('userId');
    window.addEventListener('nativeMessage', (event: any) => {
      console.log('ios even whtever', event);
      this.handleNativeMessage(event.detail);
    });
    window.addEventListener('nativeDownloadUpdate', (event: any)=>{
      console.log('downlaod event triiggerd', event.detail);
      this.handleIOsDownload(event.detail);
    })
    window.addEventListener('nativeDownloadsLoaded', (event: any) => {
      console.log('download list received', event);
    })
    window.addEventListener('handleVideoProgress', (event: any) => {
      console.log('received the tv seconds', event);
    })
  }

  handleIOsDownload(detail: any) {
    this.ngZone.run(() => {
      console.log(detail);
      const percentage = Math.min(100, Math.floor(detail.progress * 100)); 
      console.log(percentage);
      this.downloadProgressService.downloadProgressPercentage = percentage;
      if (percentage == 100) {
        this.downloadProgressService.downloadCompletedEvent.next({ success: true, item: detail });
        this.downloadProgressService.isDownloadInprogress = false;
        this.downloadProgressService.currentDownloadVideoId = null;
        console.log("Download completed:", detail);
      }
    });
    console.log("iOS detail:", detail);
  }

  private handleNativeMessage(detail: any) {
    console.log('📩 iOS nativeMessage received:', detail);
    if (detail.type === 'minimizePlayer' && detail.returnRoute) {
      this.ngZone.run(() => {
        this.router.navigateByUrl(detail.returnRoute);
      });
    }
    if (detail.type === 'maximizePlayer' && detail?.vidLibId) {
      this.ngZone.run(() => {
        this.router.navigate(['/watch'], {
          queryParams: { ref: detail.vidLibId },
        });
      });
    }
    if (detail.type === 'playbackTracking' && detail) {
      console.log("Looks like player is destroyed");
      console.log('Details got from Bad bitch club');
      console.log(detail);
      this.updateWatchHistory(detail);
      this.insertWatchEntry(detail);
      // const requestBody = {
      //   channel: detail?.channelId || "",
      //   isDrmVideo: "1",
      //   playBackMode: "server",
      //   playState: "0",
      //   secondsWatched: detail?.data?.secondsPlayed || 0,
      //   subtitleLanguage: "Stereo, 0.13 Mbps",
      //   videoDuration: detail?.vidDuration || 0,
      //   videoFileSIze: detail?.videoFileSize || 0,
      //   videoId: detail?.videoId || "",
      //   videoType: "premium",
      //   createdOn: "",
      //   eventId: "13",
      //   eventType: "13",
      //   userId: this.userId || ""
      // };
      // console.log('✅ Triggering tracking event', requestBody);
      // this.mycontentService.updateUserVideoTracking(requestBody).subscribe(
      //   res => {
      //     console.log('✅ Watch history updated');
      //     console.log('ios tracking updated', res);
      //   },
      //   error => {
      //     console.log('❌ Got error in iOS video tracking');
      //     console.error(error);
      //   }
      // );
    }
    
  }

  updateWatchHistory(detail:any) {
    const sessionSeconds = (detail?.sessionWatchedSeconds);
    if (sessionSeconds <= 0) return;
    const requestBody = {
      "channel": detail?.channelId,
      "isDrmVideo": "1",
      "playBackMode": 'server',
      "playState": "0",
      "secondsWatched": `${sessionSeconds}`,
      "currentPlaybackPosition": detail?.closedAtSeconds,
      "subtitleLanguage": "Stereo, 0.13 Mbps",
      "videoDuration": `${detail?.totalDuration || 0}`,
      "videoFileSIze": `${detail?.videoFileSize}`,
      "videoId": detail?.videoId,
      "videoType": detail?.videoType,
      "createdOn": this.formatDateTime(),
      "eventId": "13",
      "eventType": '13',
      "userId": this.userId.toString()
    };
    this.mycontentService.updateUserVideoTracking(requestBody)
      .subscribe({
        next: (res) => {
          console.log("Watch history updated — session watch time:", sessionSeconds, "s");
        },
        error: (error) => {
          console.error("Error updating watch history:", error);
        }
      });
  }

  insertWatchEntry(detail:any) {
    const requestBody = {
      vidLibId: detail?.videoId,
      lastPositionMs: Math.round(detail?.closedAtSeconds * 1000),
      durationMs: Math.round((detail?.totalDuration || 0) * 1000),
      channelId: detail?.channelId,
      incrementWatchTimeMs: Math.round((detail?.sessionWatchedSeconds) * 1000)
    };
    this.mycontentService.insertWatchHistory(requestBody)
      .subscribe({
        next: (res) => {
          console.log('Watch history upserted:', res);
        },
        error: (error) => {
          console.error('Error upserting watch history:', error);
        }
      });
  }

  formatDateTime() {
    const currentDate = new Date();
    return currentDate?.getDate() + '-' + currentDate?.toLocaleString('default', { month: 'short' }) + '-' + currentDate?.getFullYear() + ' ' + currentDate?.getHours() + ':' + currentDate?.getMinutes() + ':' + currentDate?.getSeconds();
  }

  private getIOSHandler(handler: IOSHandler) {
    return (window as any)?.webkit?.messageHandlers?.[handler];
  }

  private getAndroidHandler(handler: string) {
    return (window as any)?.AndroidTv?.[handler] || null;
  }

  isIOS(): boolean {
    return !!(window as any)?.webkit;
  }

  isAndroidTV(): boolean {
    return !!(window as any)?.AndroidTV;
  }
  
  send(handler: any, payload: any): void {
    const ios = this.getIOSHandler(handler);
    const android = this.getAndroidHandler(handler);
    if (ios) {
      ios.postMessage(payload);
      console.log(`📤 iOS → ${handler}`, payload);
      return;
    }
    if (android) {
      android.postMessage ? android.postMessage(payload) : android(payload); 
      console.log(`📤 Android/TV → ${handler}`, payload);
      return;
    }
    console.warn(`❌ No native handler available '${handler}'`, payload);
  }
  // send(handler: IOSHandler, payload: any): void {
  //   const nativeHandler = this.getHandler(handler);
  //   if (!nativeHandler) {
  //     console.warn(`❌ iOS handler '${handler}' not available`, payload);
  //     return;
  //   }
  //   nativeHandler.postMessage(payload);
  //   console.log(`📤 Message sent to '${handler}':`, payload);
  // }

  login(payload: any) {    
    this.send('loginHandler', payload);
  }

  openVideoPlayer(payload: any) {
    if(this.isAndroidTV()){
      this.send('openVideoPlayer', payload);
    }
    if(this.isIOS()){
      this.send('iosVideoPlayer', payload);
    }
  }

  sendIosPaymentDetails(payload: any){
    this.send('iapHandler', payload);
  }

  download(payload: any) {
    this.send('downloadHandler', payload);
  }

  purchase(payload: any) {
    this.send('iapHandler', payload);
  }

  recoNavigation(payload: any){
    this.send('recoNavigation', payload);
  }
  
  getCurrentDomain() {
    const host = window.location.host;
    if (host.includes('dev.toqqer.com')) return 'https://dev.toqqer.com/toqqer/static/toqqer-ui';
    if (host.includes('toqqer.com')) return 'https://toqqer.com/ui';
    if (host.includes('toqqerstage.com')) return 'https://toqqerstage.com/ui';
    if (host.includes('homecinemaplus.tv')) return 'https://homecinemaplus.tv';
    return 'UNKNOWN';
  }
 
  requestDownloadList() {
    this.send('sendDownloadList', { request: true });
  }  
}